module.exports = __webpack_public_path__ + "static/media/maps.b5c0f297.png";